if (!window.Eurus.loadedScript.has('menu-drawer.js')) {
window.Eurus.loadedScript.add('menu-drawer.js');

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store('xMenuDrawer', {
      show: false,
      rendered: false,
      hideTimer: null,
      loading: false,
      currentMenuLinks: [],
      open() {
        clearTimeout(this.hideTimer);
        this.rendered = true;
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (this.rendered) this.show = true;
        }));
        Alpine.store('xPopup').open = true;
      },
      close() {
        this.show = false;
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(() => {
          if (!this.show) this.rendered = false;
        }, 500);
        Alpine.store('xPopup').close();
      },
      setActiveLink(linkId) {
        this.currentMenuLinks.push(linkId);
      },
      removeActiveLink(linkId) {
        const index = this.currentMenuLinks.indexOf(linkId);
        if (index !== -1) {
          this.currentMenuLinks.splice(index, 1);
        }
      },
      resetMenu() {
        this.currentMenuLinks = [];
      },
      scrollTop(el = null) { 
        document.getElementById('menu-navigation').scrollTop = 0; 
        if (el) {
          el.closest('.scrollbar-body').scrollTop = 0;
        }
      }
    });
  });
});
}